export const salesDashboardEn = {
  salesDashboard: {
    title: 'Sales Dashboard',
    subtitle: 'Delivered quantities, comparisons, and target tracking',
    loading: 'Loading...',
    noData: 'No data available',
    lastUpdated: 'Last updated',
    stats: {
      totalTons: 'Total Delivered',
      deliveries: 'Deliveries',
      totalTrips: 'Total Trips',
      change: 'Period Change',
      changeTons: 'Change (Tons)',
      tons: 'tons',
      increase: 'Increase',
      decrease: 'Decrease',
      noChange: 'No Change',
      daysWithData: 'Active Days',
      activeDays: 'Active Days',
      days: 'days',
      avgDaily: 'Avg Daily',
      tonsPerDay: 'tons/day',
      vsPreviousPeriod: 'vs Previous Period',
      vsSamePeriodLastYear: 'vs Same Period Last Year',
      current: 'Current',
      previous: 'Previous',
    },
    chart: {
      dailyTitle: 'Daily Delivered Quantities',
      comparisonTitle: 'Comparison',
      deliveredTons: 'Delivered (tons)',
    },
    comparison: {
      dod: 'DoD',
      wow: 'WoW',
      mom: 'MoM',
      dodFull: 'Day over Day',
      wowFull: 'Week over Week',
      momFull: 'Month over Month',
    },
    breakdown: {
      label: 'Breakdown by',
      none: 'No Breakdown',
      title: 'Breakdown',
      factory: 'Factory',
      customer: 'Customer',
      city: 'Delivery Location',
      sku: 'Product (SKU)',
      variant: 'Product',
      name: 'Name',
      currentTons: 'Current (tons)',
      currentOrders: 'Orders (Current)',
      previousTons: 'Previous (tons)',
      previousOrders: 'Orders (Previous)',
      changePct: 'Change %',
    },
    dateRange: {
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This Week',
      lastWeek: 'Last Week',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      thisQuarter: 'This Quarter',
      thisYear: 'This Year',
      last30Days: 'Last 30 Days',
      custom: 'Custom',
    },
    filters: {
      label: 'Filters',
      searchFactory: 'Search factories...',
      searchCustomer: 'Search customers...',
      searchCity: 'Search cities...',
      searchProduct: 'Search products...',
      clearAll: 'Clear all filters',
      noResults: 'No results found.',
      loading: 'Loading...',
      clear: 'Clear',
    },
    export: {
      button: 'Export',
      downloading: 'Exporting...',
      sheetDaily: 'Daily Sales',
      sheetBreakdown: 'Breakdown',
      colDate: 'Date',
      colTons: 'Delivered (tons)',
      colDeliveries: 'Deliveries',
      colName: 'Name',
      colCurrentTons: 'Current (tons)',
      colCurrentOrders: 'Orders (Current)',
      colPreviousTons: 'Previous (tons)',
      colPreviousOrders: 'Orders (Previous)',
      colChangePct: 'Change %',
    },
    targets: {
      title: 'Monthly Targets',
      subtitle: 'Manage delivery targets per factory',
      progressTitle: 'Target Progress',
      remaining: 'Remaining',
      addTarget: 'Add Target',
      editTarget: 'Edit Target',
      month: 'Month',
      factory: 'Factory',
      selectFactory: 'Select factory',
      variant: 'Product',
      allVariants: 'All Products (Total)',
      variantHint: 'Leave as "All Products" for a factory-level total target',
      targetQuantity: 'Target Quantity',
      notes: 'Notes',
      empty: 'No targets configured',
      status: 'Status',
      current: 'Current',
      past: 'Past',
      future: 'Future',
      total: 'Total',
      deleteConfirmTitle: 'Delete Target',
      deleteConfirmDescription: 'Are you sure you want to delete this target? This action cannot be undone.',
      deleteConfirmAction: 'Delete',
      allMonths: 'All Months',
      totalTargets: 'Total Targets',
      totalQuantity: 'Total Quantity',
      factoriesCovered: 'Factories',
      avgPerFactory: 'Avg per Factory',
      manageTargets: 'Manage Targets',
      noTargetsForMonth: 'No targets set for this month. Set targets to track delivery progress.',
      monthsWithTargets: '{{count}} months with targets',
      validation: {
        monthFormat: 'Format: YYYY-MM',
        required: 'Required',
        positive: 'Must be a positive number',
      },
    },
    subCustomers: {
      admin: {
        title: 'Sub-Customers Dashboard',
        subtitle: 'Delivered orders and tons by sub-customer',
        entity: 'Sub-customer',
        code: 'Sub-customer code',
        active: 'Active sub-customers',
        total: 'Sub-customers tons',
        topTitle: 'Top 20 sub-customers',
        searchPlaceholder: 'Search a sub-customer by name or code…',
        noSubCustomer: 'No sub-customer',
        exportThis: 'Export this sub-customer',
        exportDescription: 'Every delivered order with a sub-customer that matches the page filters and the plant/customer selected in the header.',
      },
      customer: {
        title: 'Customers Dashboard',
        subtitle: 'Delivered orders and tons by customer',
        entity: 'Customer',
        code: 'Customer code',
        active: 'Active customers',
        total: 'Customers tons',
        topTitle: 'Top 20 customers',
        searchPlaceholder: 'Search a customer by name or code…',
        noSubCustomer: 'No customer',
        exportThis: 'Export this customer',
        exportDescription: 'Every delivered order with a customer that matches the page filters and the plant selected in the header.',
      },
      mainCustomer: 'Main customer',
      plant: 'Plant',
      city: 'City',
      cementType: 'Cement type',
      orders: 'Orders',
      tons: 'Tons',
      ordersUnit: 'orders',
      share: 'Share',
      rank: '#',
      date: 'Date',
      unknownCustomer: 'Unknown customer',
      unknown: 'Unknown',
      other: 'Other',
      noData: 'No deliveries match these filters',
      lockedHint: 'Set in the header',
      rangeTooLong: 'Choose a date range of {{days}} days or less',
      view: { label: 'View', chart: 'Chart', table: 'Table' },
      kpi: {
        orders: 'Delivered orders',
        avgTonsPerOrder: 'Avg tons per order',
      },
      charts: {
        trend: 'Delivered tons and orders per day',
        byCementType: 'By cement type',
        byCity: 'By city',
        byPlant: 'By plant',
      },
      filters: {
        button: 'Filters',
        title: 'Filters',
        dateRange: 'Date range',
        clearAll: 'Clear all',
        done: 'Done',
      },
      search: { noResults: 'No matches', minChars: 'Type at least 2 characters', searching: 'Searching…' },
      detail: {
        cities: 'Cities',
        plants: 'Plants',
        cementTypes: 'Cement types',
      },
      export: {
        button: 'Export',
        title: 'Export orders',
        dateLabel: 'Date range',
        download: 'Download',
        cancel: 'Cancel',
        only: 'Only',
        empty: 'No orders to export for this date range',
        narrowRange: 'Too many orders for one file (limit 50,000 orders, at most 366 days). Narrow the date range.',
        failed: 'Export failed',
        sheet: 'Orders',
        colOrderNumber: 'Order #',
        colDeliveryDay: 'Delivery day',
      },
      error: { title: 'Could not load the dashboard', retry: 'Retry' },
    },
  },
}
